import {CatalogoApiService} from './../../service/api/catalogo.api';
import {MessageService} from 'primeng/components/common/messageservice';
import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {GlobalService} from '../../service/global.service';
import {ModalService} from '../../service/modal.service';
import {FtaService} from '../../service/fta.service';
import {PesquisasFiltroApiService} from '../../service/api/pesquisas-filtro.api';
import {ResultadoFiltroFta, FiltroDadosFta, FiltroAlteracaoEstado, ResultadoFiltroFta2} from '../../model/filtros';
import {UtilApi} from '../../service/api/util.api';
import {CookieService} from 'ngx-cookie';
import {Usuario} from '../../model/usuario';

@Component({
    selector: 'home',
    templateUrl: './home.html',
    styleUrls: ['./home.css']
})

export class HomeComponent implements OnInit {

    constructor(
        private globalService: GlobalService,
        private catalogoService: CatalogoApiService,
        private router: Router,
        public modalService: ModalService,
        private ftaService: FtaService,
        private messageService: MessageService,
        public pesquisaService: PesquisasFiltroApiService,
        private utilApi: UtilApi,
        private cookieService: CookieService
    ) {
    }

    msgs: any;
    temp = '';
    tempErro = '';

    //variaves do dashboard
    listaFTA1: ResultadoFiltroFta2 = new ResultadoFiltroFta2();
    listaFTA2: ResultadoFiltroFta2 = new ResultadoFiltroFta2();
    listaFTA3: ResultadoFiltroFta2 = new ResultadoFiltroFta2();

    loading1: boolean = true;
    loading2: boolean = true;
    loading3: boolean = true;

    isFtaAprovado: boolean = false;
    isFtaAtivado: boolean = false;

    mensagemVazio: string = 'Nenhum registro encontrado';

    pagina: number = 1;

    private sub: any;

    ngOnInit() {

        this.globalService.usuario = <Usuario>this.cookieService.getObject('usuarioAdm');
        this.globalService.renovarToken(this.globalService.usuario.refresh_token);
        this.utilApi.invocacaoRemotaComRetry(5, 1000, this, HomeComponent.prototype.carregarConstantes);

    }

    carregarConstantes() {
        this.temp = '';
        this.tempErro = '';
        this.globalService.loading = false;

        if (this.ftaService.msgFtaSalvo == 'sucesso') {
            this.temp = this.ftaService.numFtaSalvo.toString();
            //this.temp = this.ftaService.numFtaSalvo;
            /* this.modalService.exibirMensagem("Sucesso", "<p class='text-center'>FTA número <strong>" + fta + "</strong> salvo com sucesso <br /><br /><strong>Atenção:</strong> Este FTA se encontra pendente de despacho</p>", "Fechar"); */
            //this.msgs = this.mensagem.addMsgSucesso(`FTA número <strong>` + fta + `</strong> salvo com sucesso <br /><br /><strong>Atenção:</strong> Este FTA se encontra pendente de despacho</p>`);
        }

        if (this.ftaService.msgFtaSalvo == 'erro') {
            /* this.modalService.exibirMensagem("Erro", "Erro ao salvar FTA", "Fechar"); */
            //this.msgs = this.mensagem.addMsgError(`Erro ao salvar FTA`);
            this.tempErro = 'erro';
        }

        this.ftaService.msgFtaSalvo = '';
        this.ftaService.numFtaSalvo = 0;

        //aguardando despacho
        this.pesquisar(1);

        //aguardando aprovação
        this.pesquisar(2);

        //aguardando roteiro
        this.pesquisar(3);

    }

    navegarPara(destino) {
        switch (destino) {
            case 'catalogo':
                this.router.navigate(['/catalogo']);
                break;
            case 'usuario':
                this.router.navigate(['/usuario']);
                break;
            case 'arquivo-sia':
                this.router.navigate(['/arquivo-sia']);
                break;
        }
    }

    pesquisar(coTipoEstado) {

        let filtros: Array<any> = new Array<any>();
        let filtroNumero: string = '0';
        let filtroNome: string = '';
        let filtroEstado: string = '0';
        let filtroFta: FiltroDadosFta = new FiltroDadosFta();
        let filtroAlteracaoEstado: FiltroAlteracaoEstado = new FiltroAlteracaoEstado();

        filtroFta.ordenacao = 'data';
        filtroFta.codTipoEstado = coTipoEstado;
        filtros.push({'filtroFta': {'filtros': [{filtroFta}]}});

        //this.globalService.loading = true;
        this.pesquisaService.mudarPagina(this.pagina);
        this.pesquisaService.filtraFta2(filtros)
            .subscribe(
                listaItens => {
                    //this.globalService.loading = false;
                    if (coTipoEstado == 1) {
                        this.loading1 = false;
                        this.listaFTA1 = listaItens as ResultadoFiltroFta2;
                    } else if (coTipoEstado == 2) {
                        this.loading2 = false;
                        this.listaFTA2 = listaItens as ResultadoFiltroFta2;
                    } else {
                        this.loading3 = false;
                        this.listaFTA3 = listaItens as ResultadoFiltroFta2;
                    }
                },
                erro => {
                    if (coTipoEstado == 1) {
                        this.loading1 = false;
                    } else if (coTipoEstado == 2) {
                        this.loading2 = false;
                    } else {
                        this.loading3 = false;
                    }
                    this.globalService.loading = false;
                }
            );
    }

    despacharFTA(codigoFTA: number, versaoFTA: number) {
        this.globalService.loading = true;
        this.catalogoService.despacharArtefatoFta(codigoFTA, versaoFTA, 'fta', 'FTA despachado')
            .subscribe(resposta => {
                    this.modalService.exibirMensagem('Sucesso', 'Fluxo de Transmissão de Arquivo número <b>' + codigoFTA + '</b> despachado com sucesso!', 'Fechar');
                    this.modalService.incluirDadosGerados('despachoOk');
                    this.listaFTA1 = new ResultadoFiltroFta2();
                    this.loading1 = true;
                    this.pesquisar(1);
                    this.listaFTA2 = new ResultadoFiltroFta2();
                    this.loading2 = true;
                    this.pesquisar(2);
                    this.globalService.loading = false;
                },
                erro => {
                    this.globalService.loading = false;
                    this.modalService.exibirMensagem('Erro', 'Ocorreu um erro ao despachar o FTA. Favor verifique sua conexão.', 'Fechar');
                }
            );
    }

    aprovar(codigoFTA: number, versaoFTA: number) {
        this.aprovarFTA(codigoFTA, versaoFTA);
    }

    aprovarFTA(codigoFTA: number, versaoFTA: number) {
        this.catalogoService.aprovaArtefatoFta(codigoFTA, versaoFTA, 'fta', 'FTA aprovado')
            .subscribe(resposta => {
                    // this.modalService.exibirMensagem("Sucesso", "Fluxo de Transmissão de Arquivo número <b>" + codigoFTA + "</b> aprovado com sucesso!", "Fechar");
                    //this.modalService.incluirDadosGerados("despachoOk");
                    this.ativarFTA(codigoFTA, versaoFTA);
                },
                erro => {
                    this.globalService.loading = false;
                    this.modalService.exibirMensagem('Erro', 'Ocorreu um erro ao aprovar o FTA. Favor verifique sua conexão.', 'Fechar');
                }
            );
    }

    ativarFTA(codigoFTA: number, versaoFTA: number) {
        this.catalogoService.aprovaArtefatoFta(codigoFTA, versaoFTA, 'fta', 'FTA despachado');
        this.catalogoService.ativaDesativaArtefatoFta(codigoFTA, versaoFTA, 'fta', 'ativa', 'FTA ativado')
            .subscribe(resposta => {
                    this.modalService.exibirMensagem('Sucesso', 'Fluxo de Transmissão de Arquivo número <b>' + codigoFTA + '</b> aprovado e ativado com sucesso!', 'Fechar');
                    this.listaFTA2 = new ResultadoFiltroFta2();
                    this.listaFTA3 = new ResultadoFiltroFta2();
                    this.loading2 = true;
                    this.loading3 = true;
                    this.pesquisar(2);
                    this.pesquisar(3);
                },
                erro => {
                    this.globalService.loading = false;
                    this.modalService.exibirMensagem('Erro', 'Ocorreu um erro ao ativar o FTA. Favor verifique sua conexão.', 'Fechar');
                }
            );
    }

}



// WEBPACK FOOTER //
// ./src/app/home/home.ts